
import { Navigate, Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { toast } from 'sonner';
import { useUserSession } from "shared/contexts/UserContext";
import { useTranslation } from 'shared/hooks/useTranslation';

const AuthRequired = () => {
    const { t } = useTranslation();
    const { isLogged } = useUserSession();
    if (isLogged())
    {
        return <Outlet/>
    }
    else
    {
        toast.error(t('auth.mustLogInFirst'), {duration:3000});
        return (
            <Box sx={{ minHeight: '100vh' }}>
                <Navigate to="/Login" />
            </Box>
        )
    }
};

export default AuthRequired;

